export default __webpack_public_path__ + "static/media/OBS-gif.7482d35e.gif";